import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["latitude", "longitude", "status", "submit"]

  connect() {
    this.submitInitiallyDisabled = this.submitTarget.disabled
    this.submitTarget.disabled = true

    if (!navigator.geolocation) {
      this.statusTarget.textContent = "Location is unavailable in this browser."
      return
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => this.locationFound(coords),
      () => this.locationUnavailable(),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    )
  }

  locationFound(coords) {
    this.latitudeTarget.value = coords.latitude
    this.longitudeTarget.value = coords.longitude
    this.statusTarget.textContent = "Location confirmed."
    this.submitTarget.disabled = this.submitInitiallyDisabled
  }

  locationUnavailable() {
    this.statusTarget.textContent = "Allow location access to join this queue."
  }
}